// extracted by mini-css-extract-plugin
module.exports = {"errorMsg":"Image_errorMsg__dXXVU","image":"Image_image__ndTaY"};